import { render, staticRenderFns } from "./ForgotPasswordContainer.vue?vue&type=template&id=1b0fdaeb&scoped=true"
import script from "./ForgotPasswordContainer.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordContainer.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordContainer.vue?vue&type=style&index=0&id=1b0fdaeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0fdaeb",
  null
  
)

export default component.exports